import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { soundService } from '../../../../services/baseSoundService/soundService';

export const MINES_COUNT_LIMIT = {
  maxBet: 24,
  minBet: 1,
};

export const DEFAULT_MINES_COUNT = 3;
export const MINES_COUNT_PRECISION = 0;
export const MAX_BOX_COUNT = 25;
export const MINES_FIELD_STATE = {
  UnOpened: 0,
  Diamond: 1,
  Bomb: 2,
  UserSelected: 3,
};

export const MinesBetStatus = {
  lose: 0,
  win: 1,
  onHold: 7,
};

export const MINES_GAME_ID = 46;

export const MinesLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Mines,
    dataKey: 'bombCount',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <span className='cpt-table-text'>
        {spinInfo.spinData?.bombCount || spinInfo.spinData?.BombCount}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const MinesBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Mines,
    dataKey: 'bombCount',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const MinesSoundsName = {
  win: 'win',
  bet: 'bet',
  bomb: 'bomb',
  hover: 'hover',
  diamond: 'diamond',
  diamond1: 'diamond_1',
  diamond2: 'diamond_2',
  bgMusic: 'bg-music',
};

export const MinesSoundsPath = [
  {
    src: 'audio/mines/bg-music.mp3',
    name: MinesSoundsName.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      this._sounds[0]._node.bufferTime = 0.5; // need it for safari
    },
    onend: function () {
      soundService.play(MinesSoundsName.bgMusic);
    },
  },
  {
    src: 'audio/mines/bet.mp3',
    name: MinesSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/diamond_1.mp3',
    name: MinesSoundsName.diamond1,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/diamond_2.mp3',
    name: MinesSoundsName.diamond2,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/bomb.mp3',
    name: MinesSoundsName.bomb,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/diamond.mp3',
    name: MinesSoundsName.diamond,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/hover.mp3',
    name: MinesSoundsName.hover,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/mines/win.mp3',
    name: MinesSoundsName.win,
    autoplay: false,
    html5: true,
  },
];

export const MINES_RULES_KEYS = new Array(isPG() ? 21 : 10)
  .fill(null)
  .map((item, index) => index + 1);
export const MINES_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
